// src/components/Layout.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Layout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const path = location.pathname;
  const isAdmin = path.startsWith("/admin");
  const isMieter = path.startsWith("/mieter");

  const superUserId = localStorage.getItem("superUserId");
  const mieterId = localStorage.getItem("mieterId");

  const isLandingPage =
    path === `/admin/${superUserId}` || path === `/mieter/${mieterId}`;

  const handleClick = () => {
    if (isLandingPage) {
      localStorage.clear();
      navigate("/login");
    } else {
      navigate(-1);
    }
  };

  return (
    <div style={{
      position: "relative",
      zIndex: 100,
    }}>
      <div
        style={{
          position: "relative",
          padding: "1rem",
        }}
      >
        <button
          onClick={handleClick}
          style={{
            position: "absolute",
            top: "1rem",
            left: "1rem",
            padding: "8px 14px",
            borderRadius: "6px",
            backgroundColor: "#ff3b3b",
            color: "white",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 999,
          }}
        >
          {isLandingPage ? "Logout" : "Zurück"}
        </button>
      </div>

      <div style={{ marginTop: "4rem", padding: "1rem" }}>{children}</div>
    </div>
  );
}

export default Layout;
